import { IS_BROWSER } from '@/common/constant/index';
import SyncCenter from '@/renderer/scripts/CoSync/SyncCenter/SyncCenter';
import { SyncCenterLoader } from '@/renderer/scripts/CoSync/SyncCenter/SyncCenterLoader';
import user, { User } from '@/renderer/scripts/utils/user';

export function useCoSync() {
  let syncCenterloader: SyncCenterLoader | null = null;
  let lastUserInfo: CoFile.UserInfo | null = null;

  const center = () => {
    if (syncCenterloader === null) {
      throw { code: 'SyncUnavailableWhenLogOut' };
    }
    return syncCenterloader.getCenter();
  };

  const centerData = () => {
    if (syncCenterloader === null) {
      throw { code: 'SyncDataUnavailableWhenLogOut' };
    }
    return syncCenterloader.getCenterDataRelay();
  };

  const methods = {
    isCoSyncEnable(): boolean {
      return !IS_BROWSER;
    },

    onLogin(flatUserInfo: User.FlatUserInfo) {
      const userInfo: CoFile.UserInfo = { ...flatUserInfo };
      // 相同的用户和企业，当作没有变化
      if (lastUserInfo?.userId === userInfo?.userId && lastUserInfo?.organizationId === userInfo?.organizationId)
        return;

      lastUserInfo = userInfo;

      try {
        syncCenterloader?.unInit();
        syncCenterloader = new SyncCenterLoader(userInfo);
      } catch (e) {
        logger.ui.error('SyncCenterLoader onLogin failed', e);
      }
    },

    onLogout() {
      lastUserInfo = null;

      try {
        syncCenterloader?.unInit();
        syncCenterloader = null;
      } catch (e) {
        logger.ui.error('SyncCenterLoader onLogout failed', e);
      }
    },

    immediatelyLoadSyncCenter() {
      syncCenterloader?.immediatelyLoad();
    },
  };

  return {
    center,
    centerData,
    methods,
  };
}

export const coSync = useCoSync();
